import { render } from "./VoiceRecordingsDrawer.vue?vue&type=template&id=12b0c1e4&scoped=true"
import script from "./VoiceRecordingsDrawer.vue?vue&type=script&lang=js"
export * from "./VoiceRecordingsDrawer.vue?vue&type=script&lang=js"

import "./VoiceRecordingsDrawer.vue?vue&type=style&index=0&id=12b0c1e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b0c1e4"]])

export default __exports__